import React, { useEffect, useState } from "react";
import "./spinWheel.styles.css";
const WheelComponent = ({
  segments,
  segColors,
  winningSegment,
  onFinished,
  primaryColor,
  contrastColor,
  buttonText,
  isOnlyOnce = true,
  size = 290,
  upDuration = 100,
  downDuration = 1000,
  fontFamily = "proxima-nova",
  width = 50,
  height = 50,
  isPlaying
}) => {
  let currentSegment = "";
  let isStarted = false;
  const [isFinished, setFinished] = useState(false);
  let timerHandle = 0;
  const timerDelay = segments.length;
  //console.log("segments length"+timerDelay);
  let angleCurrent = 0;
  let angleDelta = 0;
  let canvasContext = null;
  //console.log(Math.PI);
  let maxSpeed = Math.PI / `${segments.length}`;
  //console.log("duratin"+downDuration);
  const upTime = segments.length * upDuration;
  const downTime = segments.length * downDuration;
  let spinStart = 0;
  let frames = 0;
  const centerX = 300;
  const centerY = 300;
  useEffect(() => {
    wheelInit();
    setTimeout(() => {
      window.scrollTo(0, 1);
    }, 0);
  }, []);
  const wheelInit = () => {
    initCanvas();
    wheelDraw();
  };

  const initCanvas = () => {
    let canvas = document.getElementById("canvas");
    if (navigator.appVersion.indexOf("MSIE") !== -1) {
      canvas = document.createElement("canvas");
      canvas.setAttribute("width", width);
      canvas.setAttribute("height", height);
      canvas.setAttribute("id", "canvas");
      document.getElementById("wheel").appendChild(canvas);
    }
     setTimeout(() => {
      canvas.click();
    }, 2000);
    canvas.addEventListener("click", spin, false);
    canvasContext = canvas.getContext("2d");
  };
  const spin = () => {
    isStarted = true;
    if (timerHandle === 0) {
      spinStart = new Date().getTime();
      // maxSpeed = Math.PI / ((segments.length*2) + Math.random())
     maxSpeed = Math.PI / segments.length;
      frames = 0;
      timerHandle = setInterval(onTimerTick, timerDelay);
    }
  };
  const onTimerTick = () => {
     if (isPlaying) {
      //console.log("pause");
    //   audio.pause();
    } else {
 //console.log("play");
    // audio.play();
    }

    //this.setState({ isPlaying: !isPlaying });
    frames++;
  //  //console.log(frames)
    draw();
    const duration = new Date().getTime() - spinStart;
    // console.log(duration)
    // console.log(upTime)
    let progress = 0;
    let finished = false;
    if (duration < upTime) {
    //console.log("If")
      progress = duration / upTime;
      angleDelta = maxSpeed * Math.sin((progress * Math.PI) / 2);
      //console.log("starting"+angleDelta);
    } else {
    // console.log("else")
       //console.log();
       // maxSpeed = Math.PI / (segments.length*2);
      if (winningSegment) {
       // console.log("if 1")
        if (currentSegment === winningSegment && frames > segments.length) {
          progress = duration / upTime;
          angleDelta =
            maxSpeed * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
          progress = 1;
          // console.log("winning else"+progress);
          //console.log("ending1"+angleDelta);
        } else {
          progress = duration / downTime;
          angleDelta =
            maxSpeed * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
           // console.log("ending"+angleDelta);
           //  console.log("winning else"+progress);
        }
      } else {
        // maxSpeed = (10*Math.PI) / segments.length;
        // console.log("winning else");
        progress = duration / downTime;
       // console.log("progress"+progress);
        angleDelta =maxSpeed * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
         // console.log("middle"+angleDelta);
      }
     // console.log("dcdvd");
      if (progress >= 1) finished = true;
    }

    angleCurrent += angleDelta;
  // console.log("anglecurent"+angleCurrent);
   while (angleCurrent >= Math.PI * 2) angleCurrent -= Math.PI * 2;
    if (finished) {
    //    audio.pause();
      setFinished(true);
      onFinished(currentSegment);
      clearInterval(timerHandle);
      timerHandle = 0;
      angleDelta = 0;
   // document.getElementById("challangesatus").html("Generating question in"+currentSegment);
    }
  };

  const wheelDraw = () => {
    clear();
    drawWheel();
    drawNeedle();
  };

  const draw = () => {
    clear();
    drawWheel();
    drawNeedle();
  };

  const drawSegment = (key, lastAngle, angle) => {
    const ctx = canvasContext;
    const value = segments[key];
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.arc(centerX, centerY, size, lastAngle, angle, false);
     ctx.shadowOffsetX=3;
   ctx.shadowOffsetY=0;
   // ctx.shadowColor = "rgb(0 0 0 / 1000%)";
    ctx.shadowBlur=5;
    ctx.lineTo(centerX, centerY);
    ctx.closePath();
    ctx.fillStyle = segColors[key];
    ctx.fill();
    ctx.stroke();
    ctx.save();
    ctx.translate(centerX, centerY);
    ctx.rotate((lastAngle + angle) / 2);
    ctx.fillStyle = contrastColor || "white";
    ctx.font = "bold 1em " + fontFamily;
    ctx.fillText(value.substr(0, 21), size / 2 + 20, 0);
    ctx.restore();
  };

  const drawWheel = () => {
   // //console.log("drawwheel");
    const ctx = canvasContext;
    //console.log(ctx)
    let lastAngle = angleCurrent;
    //console.log(lastAngle)
    const len = segments.length;
    //console.log(len);
    const PI2 = Math.PI * 2;
    ctx.lineWidth = 1;
    ctx.strokeStyle = primaryColor || "black";
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";
    ctx.font = "1em " + fontFamily;
    for (let i = 1; i <= len; i++) {
      ////console.log(i);
      const angle = PI2 * (i / len) + angleCurrent;
      // console.log("Anglelast"+lastAngle);
      // console.log("Angle"+angle);
      drawSegment(i - 1, lastAngle, angle);
      lastAngle = angle;
    }

    // Draw a center circle
    ctx.beginPath();
    ctx.arc(centerX, centerY, 50, 0, PI2, false);
    ctx.closePath();
    ctx.fillStyle = "#48863d7d";
    ctx.lineWidth = 12;
    ctx.strokeStyle = "#e6e6e6";
    ctx.fill();
    ctx.font = "bold 1.5em " + fontFamily;
    ctx.fillStyle = "#e6e6e6";
    ctx.textAlign = "center";
    ctx.backgroundColor="grey";
    ctx.fillText(buttonText || "Spin", centerX, centerY + 3);
    ctx.stroke();

    // Draw outer circle
    ctx.beginPath();
    ctx.arc(centerX, centerY, size, 0, PI2, false);
     ctx.lineWidth = 25;
   
    ctx.closePath();


    ctx.strokeStyle = "#f2f2f2";
    ctx.stroke();
  };

  const drawNeedle = () => {
    const ctx = canvasContext;
    ctx.lineWidth = 5;

    ctx.strokeStyle = contrastColor || "white";
    ctx.fileStyle = contrastColor || "white";
    ctx.beginPath();
    ctx.moveTo(centerX + 20, centerY - 50);
    ctx.lineTo(centerX - 20, centerY - 50);
    ctx.lineTo(centerX, centerY - 80);
    // ctx.moveTo(centerX, centerY);
    // ctx.lineTo(10, 10);
    // ctx.lineTo(20, 30);
    ctx.closePath();
    ctx.fill();
    const change = angleCurrent + Math.PI / 2;
    let i =segments.length -Math.floor((change / (Math.PI * 2)) * segments.length) -1;
    if (i < 0) i = i + segments.length;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = primaryColor || "black";
    ctx.font = "bold 1.5em " + fontFamily;
    currentSegment = segments[i];
    isStarted &&
      ctx.fillText(currentSegment, centerX + 10, centerY + size + 50);
    // document.getElementById('selecteditem').html(currentSegment);
  };
  const clear = () => {
   // //console.log("clear");
    const ctx = canvasContext;
    ctx.clearRect(0, 0, 1000, 800);
  };

  return (
    <div id="wheel">
   {/* <h2 style={{color:"red",margin:"0px"}}>Saturday Sail Arena</h2>
    <p style={{color:"black",marginBottom:"0px",fontWeight:"700",fontSize:"24px"}}>00:25 </p>
    <div id="challangesatus">Arena Begins, Initiating spin wheel</div>*/}
      <canvas
        id="canvas"
        width="600"
        height="600"
        style={{
          pointerEvents: isFinished && isOnlyOnce ? "none" : "auto"
        }}
      />
    </div>
  );
};
export default WheelComponent;
